import React from 'react';

const SLIDES = [
  {
    url: '/images/i4.jpeg',
    caption: 'Community volunteers',
  },
  {
    url: '/images/i3.jpeg',
    caption: 'Nutritious meals distributed to the needy',
  },
  {
    url: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=1200&q=80',
    caption: 'Fresh vegetables sourced locally',
  },
  {
    url: '/images/i1.jpeg',
    caption: 'Food for every family',
  },
  {
    url: '/images/i2.jpeg',
    caption: 'Healthy meals for the vulnerable',
  },
  {
    url: '/images/i5.jpeg',
    caption: 'Volunteers make it possible',
  },
];

export default function ImageMarquee() {
  return (
    <div className="relative overflow-hidden w-full">
      
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-amber-50 to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-amber-50 to-transparent z-10 pointer-events-none" />

      {/* Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee-content">
          {[...SLIDES, ...SLIDES].map((slide, i) => (
            <div
              key={i}
              className="relative flex-shrink-0 w-72 h-52 rounded-sm overflow-hidden group"
            >
              <img
                src={slide.url}
                alt={slide.caption}
                loading="eager"
                draggable="false"
                className="w-full h-full object-cover pointer-events-none select-none transition-transform duration-500 group-hover:scale-105"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                <span className="text-white text-xs font-medium">
                  {slide.caption}
                </span>
              </div>

              {/* Decorative corners */}
              <div className="absolute top-2 right-2 w-6 h-6 border-t-2 border-r-2 border-orange-400 opacity-60" />
              <div className="absolute bottom-2 left-2 w-6 h-6 border-b-2 border-l-2 border-orange-400 opacity-60" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}